<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title :title="'“'+name+'”报名记录'" :isSearch="true" @search="search" :searchKey="searchKey"  @emptySearch="emptySearch"></pt-page-title>
     <pt-page-factor-filter  v-if="filterLabels()&&filterLabels().length&&!detailLoading" :labels="filterLabels()" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportNotes" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="exportHistoryNotes">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
    <pt-save-sign-notes-table ref="table" :ruleActivityCode="ruleActivityCode" :params-data="paramsData" :isFromRouter="isFromRouter" :id="id">
       <template>
          <el-table-column label="备注" v-if="showRemark"> 
            <template slot-scope="scope">
            <el-button v-if="hasRemark(scope.row)" type="text" @click="viewRemark(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template  slot-scope="scope">
            <el-button type="text" @click="getDetail(scope.row)">详情</el-button>
            <el-button type="text" v-if="showButtonOfOrder(scope.row)"  @click="getOrderDetail(scope.row)">查看订单</el-button>
            </template>
          </el-table-column>
        </template>
    </pt-save-sign-notes-table>
  </div>
</template>

<script>
// 组件class前缀
import ptSaveSignNotesTable from './pt-sign-notes-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
import { storeFilterLabels } from './save-sign-notes'
import { filterLabels } from '../utils-filed'
const prefixCls = 'pt-save-sign'
export default {
  name: 'pt-save-sign',
  computed: {
    classes () {
      return `${prefixCls}`
    },

    tableData () {
      return this.$refs.table.tableData
    },
    ruleActivityCode () {
      return this.signDetail.ruleActivityCode
		},
		/*是否显示备注字段*/
		showRemark(){
			return this.ruleActivityCode!=='IMMUNE_CELL_STORAGE'
		}
  },
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    },
    signDetail: {
      type: Object
    },
    hospitalList: {
      type: Array
    },
    provinceList: {
      type: Array
    },
    exportLoading: {
      type: Boolean
    },
    loading: Boolean,
    detailLoading: Boolean
  },
  components: {
    ptSaveSignNotesTable
  },
  data () {
    return {
      searchKey: null,
      // filterLabels: filterLabels,
      params: {},
      paramsData: {},
      isFromRouter: false
    }
  },
  methods: {
    getOrderDetail (row) {
      this.$router.push(`/mall-order-all/order-detail/${row.mallOrderId}/detail`)
    },
    // 是否显示查看订单按钮
    showButtonOfOrder (row) {
      return row.mallOrderId
    },
    exportNotes () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let paramsData = this.FilterData()
          paramsData = { ...paramsData,
            searchKey: this.searchKey,
            mallRegistrationId: this.id }
          // this.params.searchKey = this.searchKey ? this.searchKey : null
          this.$emit('exportSign', paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryNotes () {
      this.$router.push('/export-history/sign?name=mall_registration')
    },
    filterLabels () {
      let data = (this.signDetail && this.signDetail.form && this.signDetail.form.fields) || []
      return [...filterLabels(data, this.hospitalList, this.provinceList, this.provinceLoading), ...storeFilterLabels] || []
    },

    FilterData (isFromRouter) {
      let data = JSON.parse(JSON.stringify(this.params))
      let paramsData = {}
      storeFilterLabels.forEach(item => {
        paramsData[item.value] = data[item.value]
        this.$delete(data, 'item.value')
        if (item.type === 'time-slot') {
          if (data[item.value] && data[item.value].index) {
            this.$delete(data[item.value], 'index')
          }
          paramsData = { ...paramsData, ...data[item.value] }
          if (data[item.value]) {
            this.$delete(data, item.value)
          }
          if (paramsData[item.value]) {
            this.$delete(paramsData, item.value)
          }
        }
      })

      paramsData = { ...paramsData, ...data }
      let params = {}
      for (let key in paramsData) {
        if (!paramsData[key]) {
          this.$delete(paramsData, key)
        }
        this.filterLabels().forEach(item => {
          if (item.needFilter && item.value === key) {
            this.$set(params, key, paramsData[key])
            paramsData = { ...paramsData, params: params }
            console.log('paramsData', paramsData)
            this.$delete(paramsData, key)
          }
        })
      }
      console.log('paramsData+++', paramsData)
      return paramsData
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = this.FilterData(isFromRouter)
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.Filter()
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      // this.paramsData.searchKey = val
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.searchKey = null
      if (this.paramsData.searchKey) {
        this.$delete(this.paramsData, 'searchKey')
      }
    },
    hasRemark (val) {
      return val.genericFormData && val.genericFormData.data && val.genericFormData.data.remark
    },
    viewRemark (val) {
      let remark = val.genericFormData && val.genericFormData.data && val.genericFormData.data.remark
      this.$alert(remark, '查看备注', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    },
    getDetail (row) {
      console.log('this.id', this.id)
      this.$router.push('/save-sign/save-sign-detail/' + row.id + '/' + this.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
